<template>
    <q-page>
        <router-view/>
    </q-page>
</template>

<script>

export default {
    name: "Statistiche",
    data() {
        return {
        }
    },
}
</script>
